<template>
    <div id="modal" class="r-isfull-position">
        <div class="r-modal-box r-mtb-20-withauto">
            <div class="r-modal-form r-p-25 r-center-text" >
                <h4 class="r-mb-16">Verifikasi Email </h4>
                <p class="r-black-60-text">
                    Kami telah mengirimkan link verifikasi email ke
                </p>
                <strong>
                    {{email}}
                </strong>
                <p class="r-mtb-16 r-black-60-text">
                   Silahkan melakukan verifikasi agar anda bisa menggunakan semua fitur yang tersedia
                </p>
                <button class="r-isExpand r-primary-filled-btn r-large-size r-mtb-16" @click.prevent="closeModal()">
                    Verifikasi Nanti
                </button>
                <p class="r-black-text r-body-reguler r-isBold ">Tidak menerima email verifikasi? <span class="r-primary-text r-isBold r-isClickAble" @click.prevent="resendEmail()">Kirim Ulang</span></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed:{
        email(){
            return this.$store.getters['auth/getTempEmail'] || this.$store.getters['auth/getEmail']
        }
    },
    methods:{
        async resendEmail(){
            this.closeModal()
            await this.$store.dispatch('auth/resendEmail')
            var msg = this.$store.getters['auth/getMsg']
            var status = this.$store.getters['auth/getStatus']
            if(status == 0 ){
                this.$store.dispatch("showSnackbar", {
                    type: "error",
                    text: msg
                })
            }else{
                this.$store.dispatch("showSnackbar", {
                    type: "success",
                    text: msg
                })
            }
        },
        closeModal(){
            this.$store.dispatch('setModal',null)
        },
    }
}
</script>